const APP_AVAILABILITY_REMINDER_TYPE = "app:product:reavailability";

function notify(email) {
    const event = new Event(APP_AVAILABILITY_REMINDER_TYPE);
    event.detail = {
        email: email
    };
    document.dispatchEvent(event);
}

export default {
    notify
}
